import React from 'react';
import { keyList } from './data';
import './Styles/Key.scss';
import {ReactComponent as Lines} from '../../../Assets/Icons/lines.svg';
const Key=()=>{
    return(
        <div className="key-status">
           <h1>Status key:</h1>
           <ul>
               {keyList.map((item) =>{
                   return(
                       <li>
                           {item.icon}
                           <p>{item.title}</p>
                       </li>
                   )
               })}
           </ul>
           <div className="second">
               <h1>Past Incidents</h1>
               <p>Last 30 days</p>
           <Lines />
           </div>
        </div>
    )
};
export default Key ;